export enum Sizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  EXTRA_LARGE = 'extra_large',
  XX_LARGE = 'xx_large',
  XXX_LARGE = 'xxx_large',
  XXXX_LARGE = 'xxxx_large',
}
